import 'core-js'
import 'isomorphic-fetch'
import Helpers from './Helpers'
import { formatCurrency } from './formsUI'
import { sess } from './storage'

/* initiate the module */
window.FOD_WRAPPER = (function fod_site_module() {
	/* Helpers / theme vars / session and local storage mods will be the blocking site js wrapper module */
	// const isIE = getIsIE ();
	// const t0 = performance.now()

	const isIE = /*@cc_on!@*/ false || !!document.documentMode
	var setupUI = () => {
		/************ local vars *************/
		const BODY = document.body
		const FLYOUT_DATA_ATTRIBUTE = 'flyout-menu'
		const SEARCH_DATA_ATTRIBUTE = 'search-menu'
		const ACCORDION_DATA_ATTRIBUTE = 'accordion-show'
		const SLIDE_TOGGLE_ATTRIBUTE = 'slide-panel'
		var headerRowNav, headerSearch

		var publicAPI = {
			init,
		}

		/* [;click', 'blur'] callBack, document.querySelectorAll('.my-class');  */
		const addMultipleEvents = events => fn => node => events.map(e => attachHandler(node, e, fn))

		return publicAPI

		/* **************** Module methods **************** */
		function init() {
			/******  Elements ******/
			headerSearch = document.getElementById('header-search')
			/* currency inputs */
			var currencyInput = document.querySelectorAll('[data-type="currency"]')
			if (currencyInput) {
				addMultipleEvents(['keyup', 'blur'])(formatCurrency)(currencyInput)
			}
			headerRowNav = document.querySelector('.header-row__nav')
			var newResLink = document.querySelectorAll('[data-href="/rental/reservation/edit/"]')
			var slideToggleAll = document.querySelectorAll('[data-open="slide-panel"]')
			var sideMenuToggle = document.querySelectorAll('[data-toggle-menu="flyout"]')
			var accordionToggle = document.querySelectorAll('[data-accordion-show]')
			var searchMenuToggle = document.querySelectorAll('[data-toggle-menu="header-search"]')
			var overlay = [document.querySelector('#page-overlay')]
			// var modalOpen = document.querySelectorAll('[data-activate="modal"]')

			/****** EVENTS****** */
			/* accordion toggles */
			attachHandler(accordionToggle, 'click', toggleAccordion)
			/* modal */
			attachHandler(newResLink, 'click', launchNewResModal)
			/* side menu button */
			attachHandler(sideMenuToggle, 'click', toggleSideMenuAttr)
			/* search menu button */
			attachHandler(searchMenuToggle, 'click', toggleSearchMenuAttr)
			/* overlay handler */
			attachHandler(overlay, 'click', toggleOverlay(toggleSideMenuAttr, App.getSideNav))
			/* expand all expandibel items on page */
			attachHandler(slideToggleAll, 'click', toggleAllSlides)
			/* Tap into any click here  */
			bodyClickHandlers(clearJourneyPlannerSession, Helpers.addTextAttrToTextInputs, toggleSlideParent)
			if (isIE) {
				// doIE('window')
			}
		}
		function clearJourneyPlannerSession(e) {
			if (e.target.dataset && e.target.dataset.clearSession) {
				if (sess.isSet('JourneyPlanner')) {
					sess.removeItem('JourneyPlanner')
				}
			}
			return e.target
		}
		function bodyClickHandlers(...fns) {
			fns.forEach(fn => {
				BODY?.addEventListener('click', fn)
			})
		}
		function setUIdataAttribute(element, attribute, val) {
			// console.log(attribute, val)
			element.dataset[attribute] = val
		}
		function attachHandler(nodes, handler, fn) {
			if (!nodes.length) return
			;[...nodes].forEach(el => {
				if (el !== null) {
					return el.addEventListener(handler, fn)
				}
			})
		}
		function toggleOverlay(fn, open) {
			return function overlayLogic() {
				return !open() ? false : fn()
			}
		}

		function launchNewResModal() {
			// openModal(e).then(newResInit)
		}

		function toggleSideMenuAttr() {
			// get current side nav state
			var currentState = Helpers.boolToNum(App.getSideNav())
			// toggle the value
			var nextState = Helpers.boolToNum(!currentState)
			// update the state logic in the app
			App.setSideNav(nextState)
			// manipulate the DOM
			setUIdataAttribute(BODY, Helpers.snakeToCamel(FLYOUT_DATA_ATTRIBUTE), nextState)
			/* blurrgh */
			if (isIE) {
				doIE('sidebar')
			}
		}
		function toggleAllSlides() {
			console.log([...document.querySelectorAll(`[data-toggle="${SLIDE_TOGGLE_ATTRIBUTE}"]`)])
			return [...document.querySelectorAll(`[data-toggle="${SLIDE_TOGGLE_ATTRIBUTE}"]`)].map(e =>
				e.classList.contains('slide') ? '' : e.classList.add('slide')
			)
		}
		function toggleSlideParent(e) {
			var parent = e.target.parentNode
			if (e.target.classList.contains('expand-collapse')) {
				parent.classList.contains('slide') ? parent.classList.remove('slide') : parent.classList.add('slide')
			}
			return e.target
		}
		function toggleAccordion(e) {
			var currentState = Number(e.target.dataset.accordionShow)
			setUIdataAttribute(e.target, Helpers.snakeToCamel(ACCORDION_DATA_ATTRIBUTE), Number(Boolean(!currentState)))
		}
		/* toggles mod?! */
		function toggleSearchMenuAttr() {
			// get current side nav state
			var currentState = Helpers.boolToNum(App.getSearch())
			// toggle the value
			var nextState = Helpers.boolToNum(!currentState)
			// update the state logic in the app
			App.setSearch(nextState)
			// manipulate the DOM
			setUIdataAttribute(BODY, Helpers.snakeToCamel(SEARCH_DATA_ATTRIBUTE), nextState)
			if (isIE) {
				doIE('search')
			}
		}
		/* separate IE mod */
		function doIE(element) {
			if (element === 'sidebar') {
				headerRowNav.style.transform = App.getSideNav() == true ? 'translateX(0)' : 'translateX("300px")'
			}

			/* header Search */
			if (!headerSearch || headerSearch === null) {
				return
			}
			if (element === 'search' && window.innerWidth < Helpers.tablet) {
				headerSearch.style.display = App.getSearch() == true ? 'block' : 'none'
			}
			if (element === 'window') {
				window.addEventListener('resize', function () {
					if (window.innerWidth > Helpers.tablet - 1) {
						headerSearch.style.display = 'block'
					}
				})
			}
		}
	}

	var setupApp = () => {
		const setSideNav = bool => (showSideNav = bool)
		const getSideNav = () => showSideNav
		const setSearch = bool => (showSearch = bool)
		const getSearch = () => showSearch
		var showSearch = false
		var showSideNav = false
		var publicAPI = {
			setSideNav,
			getSideNav,
			setSearch,
			getSearch,
		}
		return publicAPI
	}

	var attachToReact = () => {
		const getById = id => document.getElementById(id)
		let elements = [
			getById('journey-planner-app'),
			getById('rental-reports-app'),
			getById('car-club-dropdown'),
			getById('car-club-app'),
			getById('department-app'),
			getById('offhire-modal'),
		]
		const ids = elements.map(e => e && e !== null).indexOf(true) !== -1
		if (document.body && document.body.dataset && document.body.dataset.mdr1Headerandsidebar === '0') {
			elements = [...elements, document.body]
			importReactApps()
		} else {
			window.addEventListener('DOMContentLoaded', () => {
				if (ids) {
					importReactApps()
				}
			})
		}
		function importReactApps() {
			import('./react-apps/index').then(fodApps => fodApps.default())
		}
	}

	attachToReact()
	var App = setupApp()
	var UI = setupUI(App)
	UI.init()
	return { Helpers, React: { active: false, attachToReact } }
})()
